import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute, DomainRedirect } from '../utils/domain/routingComponents'
import {
  legacyOrdersDeliveryPartnerScopedAccessControl,
  legacyOrdersPickupPartnerScopedAccessControl,
} from '../access-control/legacyOrdersAccess.configuration'

const LegacyOrdersListPartnerScopedPage = lazy(
  () =>
    import(
      /* webpackChunkName: "LegacyOrdersListPartnerScopedPage" */
      '../pages/orders-list/LegacyOrdersListPartnerScopedPage'
    )
)

/**
 * Legacy Orders Partner-Scoped Router
 *
 * Partner-scoped (multi-banner) routes for the multi-retailer orders list.
 */
export const legacyOrdersPartnerScopedRouter = (
  <DomainRoute route="legacy-orders-partner-scoped">
    <DashSwitch>
      <DomainRoute
        exact
        route="legacy-orders-partner-scoped-delivery"
        accessControl={legacyOrdersDeliveryPartnerScopedAccessControl}
        component={() => <LegacyOrdersListPartnerScopedPage orderType="delivery" />}
      />
      <DomainRoute
        exact
        route="legacy-orders-partner-scoped-pickup"
        accessControl={legacyOrdersPickupPartnerScopedAccessControl}
        component={() => <LegacyOrdersListPartnerScopedPage orderType="pickup" />}
      />
      <DomainRedirect to="legacy-orders-partner-scoped-delivery" />
    </DashSwitch>
  </DomainRoute>
)
